<!--
 * @Description: 个体自然人完税证明
 * @Date: 2023-02-24 14:02:57
-->
<template>
  <table-render
    :config="config"
    :propData="propData"
    style="padding:20px 10px;margin-top:0;height: initial;"
  ></table-render>
</template>

<script>
import tableRender from '@/components/tableRender';
import { taxPayment } from '@/api/ajax';
import dateFormat from '@/tools/dateFormat';
import createExtend from '@C/createExtend';
import PaymentDetail from './PaymentDetail';
import UploadProve from './UploadProve.vue';
let endDt = new Date();
let startDt = new Date();
startDt.setMonth(startDt.getMonth() - 12);
startDt = dateFormat(startDt, 'YYYY-MM-DD');
endDt = dateFormat(endDt, 'YYYY-MM-DD');
const individualNameSerch = {
  id: 'individualName',
  label: '个体名称',
  tip: '请输入',
  maxLength: 30,
  key: 'individualName',
  clearable: true,
  slot: 'input'
};
const enterpriseIdentifierName = {
  label: '个体名称',
  prop: 'enterpriseIdentifierName'
};
const feeProjectName = {
  label: '征收项目',
  prop: 'feeProjectName'
};
const feeItemName = {
  label: '征收品目',
  prop: 'feeItemName'
};
const feeStatus = {
  label: '缴费状态',
  prop: 'feeStatus',
  formatter: (r, c, v) => {
    return { 0: '未缴费', 1: '已缴费' }[v];
  }
};
const auditStatus = {
  label: '审核状态',
  prop: 'auditStatus',
  formatter: (r, c, v) => {
    return { 1: '待审核', 2: '已驳回', 3: '已审核' }[v];
  }
};
const addUpload = {
  name: '新增上传',
  type: 'warning',
  fn: (app, table) => {
    createExtend(UploadProve).$on('refresh', () => {
      table.$message.success('操作成功');
      table.getPageList(1);
    });
  }
};

const allDownLoad = {
  name: '批量下载',
  type: 'primary',
  fn: (app, table) => {
    const type = { 1: 1, 0: 2 }[table.childActiveIndex];
    taxPayment
      .individualNaturalPersonDownload({ ...table.searchQuery, type })
      .then(res => {
        table.$message.success(res.pdata);
      });
  }
};
const operate = {
  label: '操作',
  render: (h, ctx, row) => {
    const showModal = () => {
      createExtend(PaymentDetail, { row, isEdit: true }).$on('refresh', () => {
        ctx.parent.$message.success('操作成功');
        ctx.parent.getPageList(1);
      });
    };
    const download = () => {
      const type = { 1: 1, 0: 2 }[ctx.parent.childActiveIndex];
      taxPayment
        .individualNaturalPersonDownload({ id: row.id, type })
        .then(res => {
          ctx.parent.$message.success(res.pdata);
        });
    };
    const reUpload = () => {
      createExtend(UploadProve, { row, isEdit: true }).$on('refresh', () => {
        ctx.parent.$message.success('操作成功');
        ctx.parent.getPageList(1);
      });
    };
    return (
      <div>
        {row.auditStatus !== 3 && (
          <el-button
            onClick={() => {
              reUpload();
            }}
            type="text"
          >
            重新上传
          </el-button>
        )}
        {row.auditStatus === 3 && (
          <span>
            <el-button
              onClick={() => {
                showModal();
              }}
              type="text"
            >
              查看
            </el-button>
            <el-button
              onClick={() => {
                download();
              }}
              type="text"
            >
              下载
            </el-button>
          </span>
        )}
      </div>
    );
  }
};
export default {
  components: { tableRender },
  props: {
    specialType: {
      type: Number
    }
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    config() {
      return [
        {
          name: '个体自然人完税证明',
          childMenu: [
            {
              name: '我收到的',
              list: data => {
                return new Promise(resolve => {
                  const res = taxPayment.individualPerson.individualNaturalPersonList(
                    {
                      ...data,
                      type: 2
                    }
                  );
                  resolve(res);
                });
              },
              moreBtnArr: [allDownLoad],
              search: [
                individualNameSerch,
                {
                  id: 'authTimeRange',
                  label: '接收时间',
                  tip: '时间区间',
                  required: false,
                  key: ['startDt', 'endDt'],
                  slot: 'daterange',
                  clearable: false,
                  timeHander: val => {
                    let [startDt, endDt] = val;
                    // 起始时间一年后
                    const startDtOneYearlater = new Date(startDt);
                    startDtOneYearlater.setFullYear(
                      new Date(startDt).getFullYear() + 1
                    );
                    if (
                      new Date(endDt).getTime() > startDtOneYearlater.getTime()
                    ) {
                      this.$message({
                        message: '日期选择范围：最大只能选择一年',
                        type: 'warning'
                      });
                      endDt = dateFormat(startDtOneYearlater, 'YYYY-MM-DD');
                    }
                    return [startDt, endDt];
                  },
                  val: [startDt, endDt]
                }
              ],
              fields: [
                { type: 'index', width: '58px' },
                enterpriseIdentifierName,
                feeProjectName,
                feeItemName,
                feeStatus,
                {
                  label: '接收时间',
                  prop: 'createDt',
                  formatter: (r, c, v) => dateFormat(v, 'YYYY-MM-DD') || '-'
                },
                operate
              ]
            },
            {
              name: '我发起的',
              list: data => {
                return new Promise(resolve => {
                  const res = taxPayment.individualPerson.individualNaturalPersonList(
                    {
                      ...data,
                      type: 1
                    }
                  );
                  resolve(res);
                });
              },
              moreBtnArr:
                this.specialType === 1
                  ? [addUpload, allDownLoad]
                  : [allDownLoad],
              search: [
                individualNameSerch,
                {
                  id: 'upAuthTimeRange',
                  label: '上传时间',
                  tip: '时间区间',
                  required: false,
                  key: ['startDt', 'endDt'],
                  slot: 'daterange',
                  clearable: false,
                  timeHander: val => {
                    let [startDt, endDt] = val;
                    // 起始时间一年后
                    const startDtOneYearlater = new Date(startDt);
                    startDtOneYearlater.setFullYear(
                      new Date(startDt).getFullYear() + 1
                    );
                    if (
                      new Date(endDt).getTime() > startDtOneYearlater.getTime()
                    ) {
                      this.$message({
                        message: '日期选择范围：最大只能选择一年',
                        type: 'warning'
                      });
                      endDt = dateFormat(startDtOneYearlater, 'YYYY-MM-DD');
                    }
                    return [startDt, endDt];
                  },
                  val: [startDt, endDt]
                }
              ],
              fields: [
                { type: 'index', width: '58px' },
                enterpriseIdentifierName,
                feeProjectName,
                feeItemName,
                feeStatus,
                {
                  label: '上传时间',
                  prop: 'createDt',
                  formatter: (r, c, v) => dateFormat(v, 'YYYY-MM-DD') || '-'
                },
                auditStatus,
                operate
              ]
            }
          ]
        }
      ];
    },
    propData() {
      const param = { startDt, endDt };
      return {
        query: param
      };
    }
  },
  created() {
    taxPayment.individualPerson.getEntType().then(res => {
      this.specialType = res.pdata;
    });
  }
};
</script>
<style lang="scss" scoped>
>>> .el-dialog__footer,
.el-pagination {
  text-align: center;
}
</style>
